import dayjs from "dayjs";

export const formatRow = (r) => ({
  id: r.id,
  ...r,

  creation_log: r.creation_log
    ? dayjs(r.creation_log).isValid()
      ? dayjs(r.creation_log).format("DD MMM YYYY, hh:mma").toUpperCase()
      : ""
    : "",
});
